export const enum HubMessage {
    JOIN_GROUP = 'JoinGroup',
    LEAVE_GROUP = 'LeaveGroup',
    DISPLAY_ERROR = 'DisplayError'
}

export const enum RecruitingHubMessage {
    JOBS_UPDATED = 'jobUpdated',
    LEAD_ASSIGNED = 'recruitingLeadAssigned',
    RECRUITING_DASHBOARD_ALERT = 'recruitingDashboardAlert',
    RECRUITING_DASHBOARD_JOB_ALERT = 'recruitingDashboardJobAlert',
    RECRUITING_DEAL_ALERT = 'recruitingDealAlert'
}

export const enum PdHubMessage {
    RATES_UPDATED = 'pdPayratesUpdated',
    INCENTIVE_RATES_UPDATED = 'pdIncentivePayratesUpdated',
    RATES_UPDATING = 'pdPayratesUpdating',
    INCENTIVE_RATES_UPDATING = 'pdIncentivePayratesUpdating'
}

export const enum InvoiceHubMessage {
    INVOICE_PROCESS_SUCCESS = 'invoiceProcessInvoiceSuccess',
    INVOICE_PROCESS_FAILURE = 'invoiceProcessInvoiceFailure'
}

export const enum ReverseInvoiceHubMessage {
    REVERSE_INVOICE_PROCESS_SUCCESS = 'reverseInvoiceProcessSuccess',
    REVERSE_INVOICE_PROCESS_FAILURE = 'reverseInvoiceProcessFailure'
}

export const enum ComplianceReportHubMessage {
    AUTOMATCH_RESPONSE = 'autoMatchResponse'
}

export const enum InAppNotificationMessage {
    SENT = 'inAppNotificationSentAlert'
}

export const CORE_HUB_PATH = 'azureAyaCoreHub';
export const PD_HUB_PATH = 'perDiemHub';
export const INVOICE_HUB_PATH = 'invoiceHub';
export const REVERSE_INVOICE_HUB_PATH = 'reverseInvoiceHub';
export const COMPLIANCE_REPORT_HUB_PATH = 'complianceReportHub';

// Groups are optional, but can help parse out traffic to portions of recruiters.
// Could be by state or whatever. Be creative. But this will be determined on the backend.
export const enum HubGroups {
    RECRUITING = 'recruiting'
}
export const enum PdGroups {
    FACILITY = 'Facility.',
    SYSTEM = 'System.'
}

export const REALTIME_UPDATES_ERROR_MESSAGE = 'There is an error connecting to realtime updates';
export const PD_UPDATES_ERROR_MESSAGE = 'There is an error connecting to per diem updates';
export const INVOICE_UPDATES_ERROR_MESSAGE = 'There is an error connecting to invoice updates';

export const enum AccountManagerHubMessage {
    ACCOUNT_MANAGER_DASHBOARD_ALERT = 'accountManagerDashboardAlert'
}

export const TIMECARD_HUB_PATH = 'timecardHub';
export const enum TimecardHubMessage {
    TIMECARD_SYNC_START = 'timecardSyncStarted',
    TIMECARD_SYNC_SUCCESS = 'timecardSyncComplete',
    TIMECARD_SYNC_FAILURE = 'timecardSyncFailure'
}
export const TIMECARD_UPDATES_ERROR_MESSAGE = 'There is an error connecting to timecard syncs.';

export const RTO_STARTDATE_ENDDATE_WARNING_MESSAGE = `Aya's standard contracting practice is to not allow RTO at the beginning or end of contract. 
    Please note that this contract request may be rejected with RTO listed at the beginning or end of the contract.`;
